import { MQTTService } from "./mqttService";

export let mqttService = new MQTTService();
